<template>
<div class="chapter">
<div class="inner_page">
<h1>The Lady and the Outlaw</h1>
<h3 class="sigil_not_in_toc"><i>The Kincaid Family Series: Book Three</i></h3>
<h3 class="sigil_not_in_toc">Joyce Brandon</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_title.vue?7ef05930